import React from "react";
import { Container } from "@telia/teddy";
import { Outlet } from "react-router-dom";
import SalesReportsSidebar from "./SalesReportsSidebar";

const SalesReportsLayout: React.FC = () => (
    <div className="retailer-dashboard">
        <SalesReportsSidebar />
        <main className="retailer-dashboard__main-content">
            <Container mr="200" ml="200">
                <Outlet />
            </Container>
        </main>
    </div>
);

export default SalesReportsLayout;
